import { Dialog, Flex, Text } from "@100mslive/react-ui";

import { DialogRow } from "../../primitives/DialogContent";
import { PDFHeader } from "./pdfHeader";
import { PDFInfo } from "./pdfInfo";
import { SubmitPDF } from "./submitPdf";
import { TrashIcon } from "@100mslive/react-icons";

export const UploadedFile = ({
  pdfFile,
  pdfURL,
  isValidateProgress,
  setPDFFile,
  setIsPDFUrlValid,
  setIsValidateProgress,
  onOpenChange,
}) => {
  const [fileName, ext] = pdfFile.name.split(".");
  return (
    <Dialog.Root defaultOpen onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content
          css={{
            w: "min(420px,80%)",
            overflow: "auto",
            p: "$10",
          }}
        >
          <Flex direction="column">
            <PDFHeader
              onOpenChange={onOpenChange}
              title="Sẵn sàng chia sẻ?"
              subtitle="Vui lòng kiểm tra xem tệp PDF đã chọn có chính xác không"
            />
            <DialogRow
              css={{
                fontFamily: "$sans",
                bg: "$surfaceLight",
                r: "$1",
                outline: "none",
                border: "1px solid $borderLight",
                p: "$4 $6",
                minHeight: "$11",
                c: "$textPrimary",
                fs: "$md",
                w: "100%",
                "&:focus": {
                  boxShadow: "0 0 0 1px $colors$borderAccent",
                  border: "1px solid $transparent",
                },
                mb: "$8",
                mt: "$6",
              }}
            >
              <Flex direction="row" css={{ flexGrow: "1", maxWidth: "88%" }}>
                <Text
                  css={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {fileName}
                </Text>
                <Text css={{ whiteSpace: "nowrap" }}>.{ext}</Text>
              </Flex>
              <TrashIcon
                onClick={() => setPDFFile(null)}
                style={{
                  cursor: "pointer",
                }}
              />
            </DialogRow>
            <PDFInfo />
            <SubmitPDF
              pdfFile={pdfFile}
              pdfURL={pdfURL}
              isValidateProgress={isValidateProgress}
              setIsPDFUrlValid={setIsPDFUrlValid}
              setIsValidateProgress={setIsValidateProgress}
              onOpenChange={onOpenChange}
            />
          </Flex>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
